'use client'
import React, { useContext} from 'react';
import { useLocation } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import Timer from './Timer';
import { UserContext } from '../context';

const Header = () => {

    // Getting Current Path
    const location = useLocation();

    const{state} = useContext(UserContext);


    //Finds the User Role
    const user = state && state.user && state.user.userRole == "User" ? true : false
      
    
    //Get the Path
    const myPath = location.pathname;


    // To Hide the Header in the Define Component
    const hidden = myPath === '/login' || myPath ==='/register' || myPath ==='/forgotPassword' ? "hidden" : "";


    // Set the Component Name in myPath variable
    const myPathName = myPath === '/' ? "HomePage" :
        myPath === '/myProfile' ? "My Profile" :
        myPath === '/selling-currency' ? "Selling Currency" :
        myPath === '/buying-currency' ? "Buying Currency" :
        myPath === '/local-currency-balance' ? "Local Currency Balance" :
        myPath === '/local-currency-balance/:balanceType' ? "Selling Currency" :
        myPath === '/safe' ? "Local Currency Balance - Safe" :
        myPath === '/bulk-coins' ? "Local Currency Balance - Bulk Coins" :
        myPath === '/notes' ? "Local Currency Balance - Notes" :
        myPath === '/coins-in-tray' ? "Local Currency Balance - Coins in Tray" :
        myPath === '/foreign-currency-balance' ? "Foreign Currency Balance" :
        myPath.startsWith('/foreignCurrencyPage/') && myPath.split('/')[2] && myPath.split('/')[3]
            ? (<h1 className='flex'>Foreign Currency Balance - {myPath.split('/')[2].toUpperCase()}<FaArrowRightLong className="mx-3 mt-1" />{myPath.split('/')[3].split('%20')}</h1>) :
        myPath === '/foreign-currency-balance/usd' ? (<h1 className='flex'>Foreign Currency Balance - USD<FaArrowRightLong className="mx-3 mt-1" />United States</h1>) :
        myPath === '/foreign-currency-balance/gbp' ? (<h1 className='flex'>Foreign Currency Balance - GBP<FaArrowRightLong className="mx-3 mt-1" />United Kingdom</h1>) :
        myPath === '/foreign-currency-balance/eur' ? (<h1 className='flex'>Foreign Currency Balance - EUR<FaArrowRightLong className="mx-3 mt-1" />Eurozone</h1>) :
        myPath === '/dailyFOSReport' ? " Daily FOS Report" :
        myPath === '/dailyOpeningAndClosing' ? " Daily Opening and Closing Report" :
        myPath === '/settings' ? "Settings" : ""

        
    return (
        <header className={` ${hidden} `}>
            <div className={` container mx-auto flex justify-between items-center ${!user ? "mt-12 mb-9" : ""}`}>
                <div className=" text-headings text-3xl font-medium">{myPathName}</div>
                {user && state.user.userRole == "User" && (<Timer />)}
                
            </div>
        </header>
    );
};

export default Header;